import { render, staticRenderFns } from "./FileImportProvider.vue?vue&type=template&id=6ad70028&"
import script from "./FileImportProvider.vue?vue&type=script&lang=js&"
export * from "./FileImportProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports